import { z } from "zod";
export const agentKeys = [
    "market_intelligence",
    "seo_growth",
    "video_growth",
    "product_marketing",
    "competitor",
    "ads_optimization",
    "customer",
];
export const taskStatuses = [
    "queued",
    "running",
    "waiting_input",
    "review",
    "approved",
    "rejected",
    "completed",
    "failed",
    "cancelled",
    "dead_letter",
];
export const AGENT_DEFINITIONS = [
    {
        key: "market_intelligence",
        name: "市场情报 Agent",
        purpose: "从授权接口、公开网页和浏览器证据中发现美国市场机会",
        executionLane: "intelligence",
        dailyTarget: 50,
        outputLabel: "市场机会",
        schedule: "0 6 * * *",
        requiresApproval: false,
        requiredSources: ["public_web", "browser_collector"],
    },
    {
        key: "seo_growth",
        name: "SEO 增长 Agent",
        purpose: "基于机会、产品事实和证据生成可审核的英语内容任务",
        executionLane: "text",
        dailyTarget: 10,
        outputLabel: "内容任务",
        schedule: "0 8 * * *",
        requiresApproval: true,
        requiredSources: ["opportunities", "knowledge", "product_pim"],
    },
    {
        key: "video_growth",
        name: "视频增长 Agent",
        purpose: "生成Hook、脚本、分镜、素材匹配和平台版本",
        executionLane: "video",
        dailyTarget: 20,
        outputLabel: "视频脚本",
        schedule: "0 9 * * *",
        requiresApproval: true,
        requiredSources: ["assets", "knowledge", "product_pim"],
    },
    {
        key: "product_marketing",
        name: "产品营销 Agent",
        purpose: "生成PDP、FAQ、对比页、广告文案和视频简报",
        executionLane: "text",
        dailyTarget: null,
        outputLabel: "产品营销草稿",
        schedule: null,
        requiresApproval: true,
        requiredSources: ["product_pim", "knowledge", "evidence"],
    },
    {
        key: "competitor",
        name: "竞品分析 Agent",
        purpose: "保存可追溯的竞品价格、评论、新品和广告快照",
        executionLane: "intelligence",
        dailyTarget: 1,
        outputLabel: "竞品日报",
        schedule: "0 3 * * *",
        requiresApproval: false,
        requiredSources: ["public_web", "browser_collector"],
    },
    {
        key: "ads_optimization",
        name: "广告优化 Agent",
        purpose: "根据真实广告指标生成测试、暂停或预算建议，不直接修改广告",
        executionLane: "text",
        dailyTarget: 5,
        outputLabel: "广告测试建议",
        schedule: "0 11 * * *",
        requiresApproval: true,
        requiredSources: ["ads_metrics"],
    },
    {
        key: "customer",
        name: "客户运营 Agent",
        purpose: "在受控PII权限下生成回复草稿、问题分类和FAQ建议",
        executionLane: "text",
        dailyTarget: null,
        outputLabel: "客户回复草稿",
        schedule: "0 * * * *",
        requiresApproval: true,
        requiredSources: ["shopify_customers", "shopify_orders", "klaviyo"],
    },
];
export const taskPayloadSchema = z.object({
    agentKey: z.enum(agentKeys),
    taskType: z.string().min(1).max(100),
    marketCode: z.string().trim().regex(/^[A-Z]{2,8}$/).default("US"),
    locale: z.string().trim().regex(/^[a-z]{2,3}(?:-[A-Z]{2})?$/).default("en-US"),
    productCodes: z.array(z.string().trim().regex(/^[A-Z0-9][A-Z0-9-]{0,30}$/)).max(100).default([]),
    sourceIds: z.array(z.string().uuid()).default([]),
    input: z.record(z.string(), z.unknown()).default({}),
    riskLevel: z.enum(["low", "review", "blocked"]).default("review"),
});
export const reviewDecisionSchema = z.object({
    decision: z.enum(["approve", "return"]),
    note: z.string().trim().max(2000),
    version: z.number().int().positive(),
}).superRefine((value, context) => {
    if (value.decision === "return" && value.note.length === 0) {
        context.addIssue({ code: "custom", path: ["note"], message: "退回必须填写修改原因" });
    }
});
//# sourceMappingURL=index.js.map